// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.favorites-container .page-title {
  font-size: 20px;
  font-weight: 500;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
}

.favorites-container {
  position: relative;
  font-size: 14px;
}
.favorites-container:after {
  font-family: "Material Icons";
  content: "\\e87d";
  font-size: 24px;
  position: absolute;
  right: -14px;
  top: 12px;
  pointer-events: none;
  cursor: pointer;
}
.favorites-container .mat-form-field,
.favorites-container .mat-mdc-form-field {
  width: 0 !important;
  margin: 0 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/theme/components/favorites/favorites.component.scss"],"names":[],"mappings":"AAIE;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAHJ;;AAOA;EACI,kBAAA;EACA,eAAA;AAJJ;AAKI;EACI,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;AAHR;AAKI;;EAEI,mBAAA;EACA,aAAA;AAHR","sourcesContent":["// ==========================================================================\r\n// Component: Favorites.component\r\n// ==========================================================================\r\n.favorites-container {\r\n  .page-title {\r\n    font-size: 20px;\r\n    font-weight: 500;\r\n    margin: 0;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    max-width: 300px;\r\n  }\r\n}\r\n\r\n.favorites-container{\r\n    position: relative; \r\n    font-size: 14px;\r\n    &:after {\r\n        font-family: 'Material Icons';\r\n        content: \"\\e87d\";\r\n        font-size: 24px;\r\n        position: absolute;\r\n        right: -14px;\r\n        top: 12px;\r\n        pointer-events: none;\r\n        cursor: pointer;       \r\n    }\r\n    .mat-form-field,\r\n    .mat-mdc-form-field{\r\n        width: 0!important;\r\n        margin: 0 8px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
